import { render } from "./DepartmentEdit.vue?vue&type=template&id=e8483646"
import script from "./DepartmentEdit.vue?vue&type=script&lang=js"
export * from "./DepartmentEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__